export default __webpack_public_path__ + "locales/el-GR/Common.json?hash=9cc8a374a31e0938e67c36df2f3280dc";